import ChiefAnalyticsPageWithHoc from './chief-analytics-page-with-hoc'

export default ChiefAnalyticsPageWithHoc
